import { Avatar, AVATAR_HEIGHT_24 } from '../../../Avatar'
import { FloatingTooltip } from '../../../Floating'
import Text from '../../../Text'

import * as styles from './EmailTableRowActivitiesContent.module.css'

import TaskIcon from '../../../../icons/task.svg'

function EmailTableRowActivitiesContent({ label, unread }) {
  return (
    <FloatingTooltip content={label}>
      <div className={styles.content}>
        <Avatar
          Icon={TaskIcon}
          className={styles.icon}
          size={AVATAR_HEIGHT_24}
        />
        <Text className={styles.label} unread={unread}>
          {label}
        </Text>
      </div>
    </FloatingTooltip>
  )
}

export default EmailTableRowActivitiesContent
